import { render, staticRenderFns } from "./upload-create.vue?vue&type=template&id=56b7dd91&scoped=true&"
import script from "./upload-create.vue?vue&type=script&lang=js&"
export * from "./upload-create.vue?vue&type=script&lang=js&"
import style0 from "./upload-create.vue?vue&type=style&index=0&id=56b7dd91&lang=scss&scoped=true&"
import style1 from "./upload-create.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7dd91",
  null
  
)

export default component.exports